import { useContext } from 'react';
import Context from './Context';

export default function useAdminApi() {
  const { admin } = useContext(Context);
  return admin;
}
